'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import type { ItineraryCardChangeFieldProps } from './ItineraryCard.types';
import styles from './ItineraryCardChangeField.module.css';
export function ItineraryCardChangeField(t0) {
  const $ = _c(25);
  const {
    label,
    value,
    onPress,
    onPrefetch,
    helpIcon,
    isDisabled,
    isValueSubtext
  } = t0;
  const t = useTranslations("journey");
  let t1;
  if ($[0] !== label) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /\s+/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = label.toLowerCase().replace(t2, "-");
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const testId = `change-${t1}`;
  let t2;
  if ($[3] !== label) {
    t2 = <span className={styles.label}>{label}</span>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isValueSubtext && styles.valueSubtext;
  let t4;
  if ($[5] !== t3) {
    t4 = clsx(styles.value, t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4 || $[8] !== value) {
    t5 = <span className={t4}>{value}</span>;
    $[7] = t4;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== helpIcon || $[11] !== t5) {
    t6 = <div className={styles.valueRow}>{t5}{helpIcon}</div>;
    $[10] = helpIcon;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t6) {
    t7 = <div className={styles.content}>{t2}{t6}</div>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isDisabled || $[17] !== onPrefetch || $[18] !== onPress || $[19] !== t || $[20] !== testId) {
    t8 = !isDisabled && <span className={styles.changeButtonWrap}><Button variant="neutral" size="small" onPress={onPress} onHoverStart={onPrefetch} onFocus={onPrefetch} dataTestId={testId}>{t("itinerary_change_button")}</Button></span>;
    $[16] = isDisabled;
    $[17] = onPrefetch;
    $[18] = onPress;
    $[19] = t;
    $[20] = testId;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <div className={styles.field}>{t7}{t8}</div>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}